import { getSites } from '@services/queries'
import { useQuery } from 'react-query'

export function useSites(isCampaignPerSiteEnabled) {
  const info = useQuery('sites', getSites, {
    enabled: isCampaignPerSiteEnabled,
  })

  return info
}
